export default {"src":"/_next/static/media/Polycystic Ovary Syndrome.8eecd9a5.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};